import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, Chip, Typography } from "@material-ui/core";
import {
  Image as ImageIcon,
  VideoLibrary,
  MusicNote,
  Description,
  Assignment,
} from "@material-ui/icons";
import { i18n } from "../../../translate/i18n";

// Burbuja de lo que vería el cliente en su WhatsApp (0383 FS-2.4).
// Cubre los 8 `kind` de preview que produce el backend.

const MEDIA_ICON = {
  image: ImageIcon,
  video: VideoLibrary,
  audio: MusicNote,
  document: Description,
  hsmTemplate: Assignment,
};

const MEDIA_LABEL = {
  image: "Imagen",
  video: "Video",
  audio: "Audio",
  document: "Documento",
};

const SimBubble = ({ step }) => {
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";
  const preview = step.preview || {};
  const Icon = MEDIA_ICON[preview.kind];
  const isHsm = preview.kind === "hsmTemplate";

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" mb={1}>
      <Box
        style={{
          maxWidth: "85%",
          backgroundColor: isDark ? "#2a3942" : "#ffffff",
          borderRadius: "0 8px 8px 8px",
          padding: theme.spacing(1, 1.25),
          boxShadow: "0 1px 1px rgba(0,0,0,0.15)",
          borderLeft: isHsm ? "3px solid #128C7E" : undefined,
        }}
      >
        {isHsm && (
          <Chip
            size="small"
            label={i18n.t("flowbuilders.simulator.hsmBadge") || "Plantilla WABA"}
            style={{
              backgroundColor: "#128C7E",
              color: "#fff",
              height: 18,
              fontSize: 10,
              marginBottom: 4,
            }}
          />
        )}

        {Icon && !isHsm && (
          <Box
            display="flex"
            alignItems="center"
            style={{
              gap: 6,
              padding: theme.spacing(0.75),
              marginBottom: preview.body ? 6 : 0,
              borderRadius: 6,
              backgroundColor: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
            }}
          >
            <Icon style={{ fontSize: 18, color: theme.palette.text.secondary }} />
            <Typography variant="caption" style={{ fontWeight: 600 }}>
              {preview.fileName || MEDIA_LABEL[preview.kind] || preview.kind}
            </Typography>
          </Box>
        )}

        {preview.body && (
          <Typography
            variant="body2"
            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {preview.body}
          </Typography>
        )}

        {preview.options?.length > 0 && (
          <Box mt={0.75} display="flex" flexDirection="column" style={{ gap: 4 }}>
            {preview.options.map((opt, index) => (
              <Box
                key={`${opt.value}-${index}`}
                style={{
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 6,
                  padding: "4px 8px",
                  fontSize: 12,
                  color: theme.palette.primary.main,
                  textAlign: "center",
                }}
              >
                {preview.kind === "menu" ? `${index + 1}. ${opt.label}` : opt.label}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SimBubble;
